import { render } from "./PersonCurrentAge.vue?vue&type=template&id=1e0da644"
import script from "./PersonCurrentAge.vue?vue&type=script&lang=js"
export * from "./PersonCurrentAge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__